import { FC } from "react"

import styles from "./fiveStars.module.scss";
import { OneStar } from "./OneStar";

type TFiveStarsProps = {
    averageRating?: number,
    count?: number,
    className?: string
}

export const FiveStars: FC<TFiveStarsProps> = ({ averageRating, count, className }: TFiveStarsProps) => {

    return (
        <div className={`${styles.fiveStars} ${className ? className : ""}`}>
            <OneStar averageRating={averageRating} />
            <OneStar averageRating={averageRating ? averageRating - 1.0 : undefined} />
            <OneStar averageRating={averageRating ? averageRating - 2.0 : undefined} />
            <OneStar averageRating={averageRating ? averageRating - 3.0 : undefined} />
            <OneStar averageRating={averageRating ? averageRating - 4.0 : undefined} />
            {count ? <span className={count !== 0 ? styles.countNotZero : ""} >({count})</span> : <></>}
        </div>
    );
}